// The name a screen shows for the person on the other side of a conversation,
// order or request.
//
// Since 2026-09-28 profile_directory returns NULL full_name / company_name /
// company_name_latin for a trader the caller may not identify yet — the
// owner's rule: a supplier sees a trader's name only after the trader accepts
// that supplier's offer, or once the supplier confirms their direct order
// (can_see_trader_identity(), docs/proposed-sql/trader_identity_after_acceptance.sql).
// A blank there is a decision, not missing data, so the screen says "Trader"
// rather than "—" or an empty header.
//
// Positive test (golden rule 12): only a profile whose role is BUYER becomes
// "Trader". A supplier with no name, a missing row, or a role added later keeps
// the caller's own fallback.
//
// Mirror of maabar-app src/lib/counterpartyName.js — change both together.

export const TRADER_LABEL = { ar: 'تاجر', en: 'Trader', zh: '采购商' };

export const traderLabel = (lang) => TRADER_LABEL[lang] || TRADER_LABEL.en;

export function counterpartyName(profile, lang = 'en', fallback = '—') {
  const name = [profile?.company_name, profile?.company_name_latin, profile?.full_name]
    .map((v) => String(v ?? '').trim())
    .find(Boolean);
  if (name) return name;
  if (String(profile?.role ?? '').trim().toLowerCase() === 'buyer') return traderLabel(lang);
  return fallback;
}
